import React from "react";
import classNames from "classnames";
import { Typography } from "@/components/Typography";
import { FeaturedProps } from "./types";
import { useWindowSize } from "@/hooks/useWindowsSize";

import "./styles.scss";

export const Featured = ({ items, customClass }: FeaturedProps) => {
  const screenSize = useWindowSize();

  const classnames = classNames(`Featured`, {
    [`Featured--${customClass}`]: customClass,
  });
  return (
    <div
      data-testid="Featured"
      className={classnames}>
      {items?.map((item, ind: number) => {
        return (
          <div
            className="Featured__item"
            key={ind}>
            <img
              src={`../../svg/${item.image}.svg`}
              alt={item.imageAlt}
            />

            {item.richtext.map((item, i: number) => (
              <div
                key={i}
                className={`Featured__text-container ${screenSize?.isDesktop ? "md" : "sm"}`}>
                <Typography
                  key={i}
                  Tag={item.tag}
                  size={item.size}
                  spacing={item.spacing}
                  classname={item.classname}>
                  {item.content}
                </Typography>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};
